<template>
  <Listbox v-slot="{ open }" v-model="selectedSourceOfTruth" class="col-span-3">
    <div class="relative mt-1">
      <ListboxLabel
        class="flex items-center gap-x-1 text-sm font-medium text-gray-700"
        >{{ t('company.importer.sourcreOfTruth')
        }}<HelpPopover :text="t('company.importer.sourcreOfTruthHelp')"
      /></ListboxLabel>
      <ListboxButton
        class="relative mt-1 min-h-[2.4rem] w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pr-10 pl-3 text-left shadow-xs focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-hidden sm:text-sm"
      >
        <span class="block truncate">{{ selectedSourceOfTruth.label }}</span>
        <span
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
        >
          <ChevronDownIcon
            class="mr-1 h-5 w-5 text-gray-400"
            :class="open ? 'rotate-180' : 'rotate-0'"
            aria-hidden="true"
          />
        </span>
      </ListboxButton>

      <transition
        leaveActiveClass="transition duration-100 ease-in"
        leaveFromClass="opacity-100"
        leaveToClass="opacity-0"
      >
        <ListboxOptions
          class="absolute z-1 max-h-60 w-full overflow-auto rounded-b-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm"
        >
          <ListboxOption value="" />
          <ListboxOption
            v-for="source in importerStore.availableSourceOfTruth"
            v-slot="{ active, selected }"
            :key="source.value"
            :value="source"
            as="template"
          >
            <li
              :class="[
                active ? 'bg-indigo-100 text-indigo-900' : 'text-gray-900',
                'relative cursor-default px-4 py-2 select-none',
              ]"
            >
              <span
                :class="[
                  selected ? 'font-medium' : 'font-normal',
                  'block truncate',
                ]"
                >{{ source.label }}</span
              >
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { useImporterStore } from '../../store/importerStore'
import HelpPopover from '../HelpPopover.vue'

const importerStore = useImporterStore()

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

const selectedSourceOfTruth = computed({
  get() {
    return (
      importerStore.availableSourceOfTruth.find(
        (source) => source.value === importerStore.activeConfig.sourceOfTruth,
      ) || {}
    )
  },
  set(newValue) {
    importerStore.activeConfig.sourceOfTruth = newValue.value
  },
})
</script>
